module.exports = __webpack_public_path__ + "static/fargo-cityscape-white-1390917b4be4f02fd5e9da2c937a9254.svg";